module.exports = __webpack_public_path__ + "media/assets/images/blog/tablet_doc-small-413a706c04291c85e62ef8c8b1384755.jpeg";